module.exports = __webpack_public_path__ + "img/symbol_2.cf9e3f8b.png";